// @ts-strict-ignore
import { DEFAULT_TAG_COLOR_IN_HEX_FORMAT } from 'flow/editor/components/constants';
import type { Tag } from 'flow/store/engine/types/props';

export function getTagByName(tags: Tag[], tagName: string) {
  return tags.find(
    tag => tag.tag_name.toLowerCase() === tagName.toLowerCase() && tag.archived === false,
  );
}

export function indexTagsByName(tags: Tag[]): Record<Tag['tag_name'], Tag> {
  return Object.fromEntries(tags.map(tag => [tag.tag_name, tag]));
}

export function isTagEphemeral(tag: Tag): boolean {
  if (!tag) return false;
  return Boolean(tag.is_ephemeral);
}

export function createEphemeralTag(overrides: {
  color?: Tag['tag_color'];
  description?: Tag['description'];
  isAdverseActionReason?: Tag['is_adverse_action_reason'];
  isCaseCreating?: Tag['is_case_creating'];
  name: Tag['tag_name'];
  suppressionInterval?: Tag['suppression_interval'];
}): Tag {
  return {
    app_version_count: null,
    archived: false,
    associated_types: [],
    category_id: null,
    category_name: '',
    customer_tag_id: null,
    description: overrides.description ?? null,
    is_adverse_action_reason: overrides.isAdverseActionReason ?? false,
    is_associated_to_cases: false,
    is_case_creating: overrides.isCaseCreating ?? false,
    is_ephemeral: true,
    is_federated: false,
    is_journey_app_creating: false,
    outcomes: [],
    suppression_interval: overrides.suppressionInterval ?? null,
    tag_color: overrides.color ?? DEFAULT_TAG_COLOR_IN_HEX_FORMAT,
    tag_name: overrides.name ?? '',
  };
}

export function isTagNameUnique(tagProps: Tag[], tagName: string) {
  const tagNames = new Set(tagProps.map(tag => tag.tag_name));
  return Boolean(!tagNames.has(tagName));
}
